<template>
    <layout :showuserinfo="false" title="Cukai Tanah" :crumbs="crumbs">
        <z-page
            title="Jana Bil Pukal"
            :append-button="true"
            icon="fal fa-database"
        >
            <h2>Jana Bil Untuk Daerah</h2>
            <w-flex class="justify-start">
                <div class="xs4 mr3">
                    <w-select
                        class="mb3"
                        :items="districts"
                        v-model="form.kod_daerah"
                        outline
                        label="Pilih Daerah"
                        label-position="left"
                        @input="fetchData1()"
                    >
                    </w-select>
                </div>
            </w-flex>
            <br />
            <w-form @submit.prevent="submit">
                <w-select
                    class="mt4"
                    placeholder="Sila Pilih Mukim"
                    v-model="form.kod_mukim"
                    :items="mukim"
                    label="Mukim"
                />
                <w-select
                    class="mt4"
                    placeholder="Sila Pilih Jenis Hakmilik"
                    v-model="form.kod_jenis_hm"
                    :items="jhm"
                    label="Jenis Hak Milik"
                />

                <br />
                <div class="d-flex justify-end mt3">
                    <w-button class="my1 mr0" type="submit"
                        >Jana Bil Pukal</w-button
                    >
                </div>
            </w-form>
        </z-page>
    </layout>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import ZPage from "../../../../Components/z-page.vue";

export default {
    name: "app",
    components: { ZPage },
    inject: ["page"],
    props: {},
    data() {
        return {
            districts: [{ label: "Loading", selected: true }],
            jhm: [{ label: "Loading", selected: true }],
            mukim: [{ label: "Loading", selected: true }],
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Jana Bil", route: "/cukai-tanah/janaBilPukal" },
            ],
            form: {
                kod_daerah: "01",
                kod_mukim: null,
                kod_jenis_hm: null,
            },
        };
    },
    setup() {},
    methods: {
        async submit() {
            var url1 = `${this.apiBaseUrl}/cukai/jana-bilPukal?kod_daerah=${this.form.kod_daerah}&kod_mukim=${this.form.kod_mukim}&jhm=${this.form.kod_jenis_hm}`;
            window.open(url1, "_blank");
            // window.open = (`${this.apiBaseUrl}/cukai/jana-bilPukal?kod_daerah=${this.kod_daerah}&kod_mukim=${this.form.kod_mukim}&jhm=${this.form.kod_jenis_hm}`,'_blank');
        },
        async fetchData1() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah/${this.form.kod_daerah}/mukim`,
                responseType: "json",
            }).then((e) => {
                this.mukim = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
            });
        },
        async fetchData2() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/jenisHm`,
                responseType: "json",
            }).then((e) => {
                this.jhm = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
            });
        },
        async fetchData() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah`,
                responseType: "json",
            }).then((e) => {
                this.districts = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
                this.form.kod_daerah = this.districts[0].value;
            });
        },
    },
    mounted() {
        this.fetchData();
        this.fetchData1();
        this.fetchData2();
    },
};
</script>
